import { createContext, useContext, useState, useEffect } from "react";

const CalmModeContext = createContext(null);

export function CalmModeProvider({ children }) {
  const [isCalm, setIsCalm] = useState(() => {
    return localStorage.getItem("ea_calm_mode") === "true";
  });

  useEffect(() => {
    localStorage.setItem("ea_calm_mode", isCalm);
    document.documentElement.setAttribute("data-calm", isCalm);
  }, [isCalm]);

  return (
    <CalmModeContext.Provider value={{ isCalm, setIsCalm, toggle: () => setIsCalm(p => !p) }}>
      {children}
    </CalmModeContext.Provider>
  );
}

export const useCalm = () => {
  const ctx = useContext(CalmModeContext);
  return ctx || { isCalm: false, setIsCalm: () => {}, toggle: () => {} };
};

/* Calm mode style helpers - use these in pages */
export function calmStyles(isCalm) {
  if (!isCalm) return {};
  return {
    border: "1.5px solid #c8c4bc",
    boxShadow: "none",
    borderRadius: "12px",
    transition: "all 0.4s ease",
  };
}

export function calmBg(isCalm) {
  return isCalm ? "#fafaf8" : "#f0eee9";
}

export function calmNavy(isCalm) {
  return isCalm ? "#4a4a6a" : "#29294d";
}

export function calmBorder(isCalm) {
  return isCalm ? "1px solid rgba(45,53,97,0.06)" : "1px solid rgba(45,53,97,0.08)";
}

export function calmShadow(isCalm) {
  return isCalm ? "0 1px 4px rgba(0,0,0,0.04)" : "none";
}

export function calmShadowSm(isCalm) {
  return isCalm ? "0 1px 2px rgba(0,0,0,0.03)" : "none";
}
